<template>
  <div v-if="seasonalDay" class="d-flex align-items-end">
    <img class="seasonal-img" :src="seasonalDay.img" :title="seasonalDay.title" />
    <!-- <small class="ml-1">{{ seasonalDay.title }}</small> -->
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getPublicAsset } from '@/utils/tools'

const seasonalDay = computed(() => {
  const date = new Date().toISOString()

  const seasons = [
    {
      title: 'Merry Christmas!',
      regex: /^\d{4}-12-(1[3-9]|2[0-9]|30)/,
      asset: 'jingle-bells.jpg',
    },
    {
      title: 'Happy New Year!',
      regex: /^\d{4}-(12-31|01-0[1-5])/,
      asset: 'fireworks.png',
    },
    {
      title: "Happy Valentine's day!",
      regex: /^\d{4}-02-14/,
      asset: 'valentines-day.png',
    },
    {
      title: 'Daylight saving time start',
      regex: /^2024-03-(31|31)/,
      asset: 'dst-starts.png',
    },
    {
      title: 'Nasjonaldagen (Constitution day of Norway)',
      regex: /^\d{4}-05-17/,
      asset: 'norway.jpg',
    },
    {
      title: 'Grundlovsdag (Constitution day of Denmark)',
      regex: /^\d{4}-06-05/,
      asset: 'denmark.jpg',
    },
    {
      title: 'Sveriges nationaldag (National day of Sweden)',
      regex: /^\d{4}-06-06/,
      asset: 'sweden.jpg',
    },
    {
      title: 'Midsummer',
      regex: /^2024-06-(17|18|19|20|21|22)/,
      asset: 'midsummer.jpg',
    },
    {
      title: 'Daylight saving time ends',
      regex: /^2024-10-(26|27)/,
      asset: 'dst-ends.png',
    },
    {
      title: 'Itsenäisyyspäivä (Finnish independence day)',
      regex: /^\d{4}-12-06/,
      asset: 'finland.jpg',
    },
  ]

  const day = seasons.find((season) => season.regex.test(date))
  if (day) {
    return {
      img: getPublicAsset(`seasonal/${day.asset}`),
      title: day.title,
    }
  }
  return undefined
})
</script>

<style lang="scss" scoped>
.seasonal-img {
  max-width: 80px;
  height: 40px;
  mix-blend-mode: multiply;
}
</style>
